import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';
import type {
  HotelDetailsFormModel,
  HotelDetailsModel,
} from 'lumen/routes/hotel/settings/my-property/hotel-details';
import type { ControllerWithUnsavedChanges } from 'lumen/utils/unsaved-changes-transition-handlers';

export default class HotelSettingsMyPropertyHotelDetailsController
  extends Controller
  implements ControllerWithUnsavedChanges
{
  declare model: HotelDetailsModel;
  @service declare alerting: Services['alerting'];
  @service declare intl: IntlService;

  @tracked pendingLogoChange: 'upload' | 'delete' | null = null;

  onPendingLogoChange = (value: 'upload' | 'delete' | null): void => {
    this.pendingLogoChange = value;
  };

  @cached get formModel(): HotelDetailsFormModel {
    return {
      geocodeProfileCoordsTask: this.model.geocodeProfileCoordsTask,
      requestProfileTask: this.model.requestProfileTask,
      pendingLogoChange: this.pendingLogoChange,
      onPendingLogoChange: this.onPendingLogoChange,
    };
  }

  get hasUnsavedChanges(): boolean {
    return (
      this.pendingLogoChange !== null ||
      (this.model.requestProfileTask.last?.value?.hasValuesChanges() ?? false)
    );
  }

  discardChanges(): void {
    this.pendingLogoChange = null;
    this.model.requestProfileTask.last?.value?.rollbackAttributes();
  }

  async showDiscardChangesAlert(): Promise<boolean> {
    return this.alerting.showConfirmWarningAlert({
      dangerMode: true,
      title: this.intl.t('general.unsaved_changes.title'),
      text: this.intl.t('settings.my_hotel.leave_page_alert.description'),
      buttons: {
        cancel: {
          text: this.intl.t('settings.my_hotel.leave_page_alert.cta.cancel'),
        },
        confirm: {
          text: this.intl.t('settings.my_hotel.leave_page_alert.cta.confirm'),
        },
      },
    });
  }
}
